<template>
  <div class="row">
    <div class="col-12 mb-5">
      <!-- modal -->
      <button-wrapper
        class="detail_btn mx-auto"
        :disabled="Boolean(boothQuantity)"
        @click="openStudentEnrollmentModal"
      >
        報名活動
      </button-wrapper>
    </div>
    <div class="col-12 mb-5">
      <table-wrapper>
        <table-row>
          <table-heading :cols="2">
            日期
          </table-heading>
          <table-heading :cols="2">
            時間
          </table-heading>
          <table-heading :cols="2">
            攤位數量
          </table-heading>
          <table-heading :cols="4">
            金額
          </table-heading>
          <table-heading :cols="2" />
        </table-row>
        <table-row v-if="boothQuantity">
          <table-data :cols="2">
            {{ expoInfo.expo_start_time || new Date() | moment('YYYY/MM/DD') }}
          </table-data>
          <table-data :cols="2">
            {{ expoInfo.expo_start_time || new Date() | moment('HH:mm') }} ~ {{ expoInfo.expo_end_time || new Date() | moment('HH:mm') }}
          </table-data>
          <table-data :cols="2">
            {{ boothQuantity }}
          </table-data>
          <table-data :cols="2">
            {{ expoInfo.expo_booth_charge * boothQuantity }}
          </table-data>
          <table-data
            :cols="4"
            class="px-0"
          >
            <button-wrapper
              class="mx-auto my-sm-1"
              color="blue"
              @click="openStudentEnrollmentModal"
            >
              修改攤位數量
            </button-wrapper>
            <button-wrapper
              class="mx-auto"
              color="pink"
              @click="resetQuantity"
            >
              取消報名
            </button-wrapper>
          </table-data>
        </table-row>
      </table-wrapper>
    </div>
    <bootstrap-modal
      modal-title="確認報名校園徵才博覽會？"
      :is-open="isModalOpen"
      size="sm"
      @modal:close="closeBoothNumberChoosingModal"
      @modal:okay="submitBoothNumber"
    >
      <form>
        <form-row>
          <form-group cols="12">
            <input-group>
              <template slot="prepend">
                <span
                  aria-hidden="true"
                  class="input-group-text text-muted"
                >
                  購買攤位數量
                </span>
              </template>
              <form-select
                :default-value="boothQuantity"
                :options="maxOrderQuantity | toN"
                name="booth-quantity"
                @change="selectedQuantity"
              />
            </input-group>
          </form-group>
        </form-row>
      </form>
    </bootstrap-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import ButtonWrapper from '~components/common/buttons'
import BootstrapModal from '~bootstrap/Modal'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormSelect from '~components/common/form/Select'
import InputGroup from '~components/common/form/input/Group'
import { toN } from '~utils/filters'

export default {
  name: 'CareerExpoChoosingBooth',
  components: {
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    ButtonWrapper,
    BootstrapModal,
    FormRow,
    FormGroup,
    FormSelect,
    InputGroup
  },
  filters: {
    toN
  },
  props: {
    maxOrderQuantity: {
      type: Number,
      default: 6 // 目前寫死，後台沒有設計可設定的地方
    },
    expoInfo: {
      type: Object,
      required: true
    },
    enrolledExpoInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isModalOpen: false,
      boothQuantity: '',
      tempQuantity: ''
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseCheckoutGetter'
    ]),
    didPurchaseAnyBooth () {
      return Object.keys(this.currentEnterpriseCheckoutGetter).includes('careerExpo')
    }
  },
  watch: {
    boothQuantity (value) {
      if (value > 0) {
        this.$emit('submit', {
          expo_booth_quantity: value,
          expo_charge_total: this.expoInfo.expo_booth_charge * value,
          ...this.expoInfo
        })
      } else {
        this.$emit('submit', {
          expo_booth_quantity: 0,
          expo_charge_total: 0,
          ...this.expoInfo
        })
      }
    },
    didPurchaseAnyBooth (value) {
      if (!value) {
        this.resetQuantity()
      }
    },
    enrolledExpoInfo (value) {
      this.boothQuantity = value.expo_booth_quantity
    }
  },
  created () {
    if (Object.keys(this.enrolledExpoInfo).length) {
      this.boothQuantity = this.enrolledExpoInfo.expo_booth_quantity
    }
  },
  methods: {
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    closeBoothNumberChoosingModal () {
      this.isModalOpen = false
      this.toggleModal(false)
    },
    submitBoothNumber () {
      this.boothQuantity = this.tempQuantity
      this.isModalOpen = false
      this.toggleModal(false)
    },
    openStudentEnrollmentModal () {
      this.isModalOpen = true
      this.toggleModal(true)
    },
    selectedQuantity ({ value }) {
      this.tempQuantity = value
    },
    resetQuantity () {
      this.boothQuantity = ''
    }
  }
}
</script>
